// removed by extract-text-webpack-plugin
module.exports = {"list":"_3Za7D","emptyText":"_4RbGZ"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/UniversalSearchResultsList/index.sass
// module id = 1513
// module chunks = 1